export default "* 8c36094\t 2026-05-20T16:54:12-03:00 ";